export default __webpack_public_path__ + "static/media/arrow-go-back.55806e95.svg";